export default __webpack_public_path__ + "static/media/fMaltoBuza40.0f070617.png";